// components/admin/quotes/DeleteConfirmationModal.jsx
import { X, AlertCircle } from 'lucide-react';

export default function DeleteConfirmationModal({ quote, onClose, onConfirm }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Confirmer la suppression</h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-content">
          <div className="confirmation-message">
            <AlertCircle size={48} color="#ef4444" />
            <p>Êtes-vous sûr de vouloir supprimer le devis de <strong>{quote.clientName}</strong> ?</p>
            <p className="warning-text">Cette action est irréversible.</p>
          </div>
        </div>

        <div className="modal-actions">
          <button onClick={onClose} className="btn-secondary">
            Annuler
          </button>
          <button onClick={onConfirm} className="btn-danger">
            Supprimer définitivement
          </button>
        </div>
      </div>
    </div>
  );
}